module.exports = __webpack_public_path__ + "img/pause.643975dd.png";